import axios from '../utils/axios';
import { Gate } from '../types/Gate';

export interface Route {
  id: string;
  name?: string;
  description?: string;
  route_category?: number;
  team_id?: string;
  created_at?: string;
  edit_ts?: string;
  lap_length?: number;
  bend_radius?: number;
  banking_angle?: number;
  velodrome_major_axis?: number | null;
  velodrome_center_lat?: number | null;
  velodrome_center_lon?: number | null;
}

export interface RouteWithGates {
  id: string;
  team_id: string;
  description: string;
  route_address: Record<string, string> | null;
  route_type: string | null;
  edit_ts: string | null;
  average_count: number | null;
  data_hash: string | null;
  origin_gates_lat: number[] | null;
  origin_gates_lon: number[] | null;
  route_category: number | null;
  address: string;
  gate_count: number;
  total_session_count: number;
  gates: Gate[];
}

export interface CreateRouteData {
  description: string;
  route_category: number;
  lap_length: number;
  bend_radius: number;
  banking_angle: number;
}

export async function getRoutes(queryString: string = ''): Promise<Route[]> {
  const suffix = queryString ? `?${queryString}` : '';
  return axios.get(`/routes${suffix}`).then((res) => res?.data ?? []);
}

export async function updateRoute(routeId: string, data: Partial<Route>): Promise<Route> {
  return axios.put(`/routes/${routeId}`, data).then((res) => res?.data);
}

export async function createRoute(data: CreateRouteData): Promise<Route> {
  return axios.post('/routes', data).then((res) => res?.data);
}

export async function deleteRoute(routeId: string): Promise<any> {
  return axios.delete(`/routes/${routeId}`).then((res) => res.data);
}

export async function retrieveRouteAddresses(
  routeIds: string[],
): Promise<{ updated: number }> {
  return axios
    .post('/routes/retrieve-addresses', { route_ids: routeIds })
    .then((res) => res.data);
}

export async function getRoutesForManagement(): Promise<RouteWithGates[]> {
  return axios
    .get('/routes?scope=route_management')
    .then((res) => res?.data ?? []);
}
